"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = exports.InputElement = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const react_1 = require("react");
const Label_1 = require("./Label");
const styles_1 = require("../../constants/styles");
const useValidate_1 = require("../../hooks/useValidate");
const ErrorMessage_1 = require("../ErrorMessage");
exports.InputElement = styled_1.default.input(styles_1.inputStyles);
const Input = (props) => {
    const [touched, setTouched] = (0, react_1.useState)(false);
    const value = props.type === 'number' ? Number(props.value) : props.value;
    const validateError = (0, useValidate_1.useValidate)(props.schema, props.required, value);
    const handleBlur = (event) => {
        if (props.onChange && props.formatter) {
            props.onChange(props.formatter(event.target.value));
        }
        props.onBlur?.(event);
        setTouched(true);
    };
    const handleChange = (event) => {
        props.nativeOnChange?.(event);
        props.onChange?.(event.target.value);
    };
    const errorMessage = props.errorMessage ?? validateError;
    const showError = (touched || props.forceShowError) && !!errorMessage;
    const inputAndErrorMessage = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(exports.InputElement, { autoFocus: props.autoFocus, autoComplete: 
                // We'll use "nope" as a nonsense value, as some browsers ignore "off":
                props.autoComplete === 'off' ? 'nope' : props.autoComplete, autoCapitalize: props.autoCapitalize, bold: props.bold, disabled: props.disabled, fullWidth: props.fullWidth, icon: props.icon, invalid: showError, onBlur: handleBlur, onChange: handleChange, onClick: props.onClick, onFocus: props.onFocus, id: props.id, onKeyDown: props.onKeyDown, placeholder: props.placeholder || (props.label ? `${props.label}...` : undefined), required: props.required, size: props.size, styles: props.styles, type: props.type, value: props.value ?? undefined, maxWidth: props.maxWidth }), (0, jsx_runtime_1.jsx)(ErrorMessage_1.ErrorMessage, { errorMessage: showError ? errorMessage : undefined, reserveSpace: props.reserveErrorSpace })] }));
    return props.label ? ((0, jsx_runtime_1.jsx)(Label_1.Label, { description: props.description, fullWidth: props.fullWidth, icon: props.labelIcon, required: props.required, text: props.label, color: props.labelColor, placement: props.placement, children: inputAndErrorMessage })) : (inputAndErrorMessage);
};
exports.Input = Input;
